module.exports = __webpack_public_path__ + "static/media/kredyt_mastercard.1a34b4d6.png";